// extracted by mini-css-extract-plugin
module.exports = {"screenMessage":"PageBoundary-screenMessage"};